
import { defineComponent } from 'vue';
import Message from '@/components/atoms/Message.vue';
import { postMessageToParent, redirectToCallbackURL, signOut } from '@/service/cognitoService';
import { cleanSessionStorage } from '@/plugins/session';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Logout',
  components: {
    Message
  },
  data () {
    return {
      messageType: 'success',
      messageText: this.$t('message.logout_success')
    };
  },
  async mounted () {
    try {
      await signOut();
      cleanSessionStorage();
      return this.isIframe
        ? postMessageToParent({
          idToken: this.idToken,
          accessToken: this.accessToken,
          refreshToken: this.refreshToken
        })
        : redirectToCallbackURL();
    } catch (error) {
    }
  },
  computed: {
    ...mapGetters([
      'isIframe',
      'idToken',
      'accessToken',
      'refreshToken'
    ])
  }
});
